import { useId } from "react";

export default function Logo({ animated = false }) {
  const clipId = `lg${useId().replace(/:/g, "")}`;
  return (
    <svg
      className={animated ? "logo-mark is-animated" : "logo-mark"}
      width="34"
      height="34"
      viewBox="-6 -6 112 112"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M2 46 H98" style={{ stroke: "var(--accent2)" }} strokeWidth="8" strokeLinecap="round" />
      <rect x="8" y="26" width="38" height="42" rx="14" style={{ fill: "var(--bg)", stroke: "var(--ink)" }} strokeWidth="7" />
      <rect x="54" y="26" width="38" height="42" rx="14" style={{ fill: "var(--bg)", stroke: "var(--ink)" }} strokeWidth="7" />
      <clipPath id={clipId}>
        <rect x="12" y="30" width="30" height="34" rx="10" />
        <rect x="58" y="30" width="30" height="34" rx="10" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect x="0" y="30" width="100" height="34" fill="#3dd8ff" opacity="0.25" />
        <rect className="scan" x="0" y="38" width="100" height="8" style={{ fill: "var(--accent)" }} />
      </g>
      <path d="M44 66 Q50 74 56 66" style={{ stroke: "var(--ink)" }} strokeWidth="5" fill="none" />
    </svg>
  );
}
